import PriceWidget from '../../components/price-widget/PriceWidget';
import { addToCartUtlityFn } from '../../utils/equipment';
import { Box, styled } from '@mui/material';
import { PrimaryButton } from '../../components/Buttons';

interface AddonsCTAProps {
  equipmentId: string | number;
}

const StyledPriceWidget = styled(PriceWidget)`
  margin: 6px 0;
`;

function AddonsCallToAction({ equipmentId }: AddonsCTAProps) {
  const handleAddToCart = () => {
    addToCartUtlityFn(equipmentId, 1);
  };

  return (
    <Box>
      <StyledPriceWidget equipmentId={equipmentId} day />
      <PrimaryButton onClick={handleAddToCart}>Add to cart</PrimaryButton>
    </Box>
  );
}

export default AddonsCallToAction;
